// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.flex-row[data-v-fe506904] {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n.flex-grow-1[data-v-fe506904] {\n  flex-grow: 1;\n}\n.flex-grow-2[data-v-fe506904] {\n  flex-grow: 2;\n}\n.no-wrap[data-v-fe506904] {\n  display: flex;\n  flex-wrap: nowrap;\n}\n.icon i[data-v-fe506904] {\n  font-size: 1.7rem;\n}\n.display-none[data-v-fe506904] {\n  display: none;\n}\n.margin-top-30[data-v-fe506904] {\n  margin-top: 2.2rem;\n}\n", ""]);
// Exports
module.exports = exports;
